<template>
  <div class="scroller">
    <div class="resource">
      <h2 class="resource__heading" v-if="action === 'create'">New slider</h2>
      <h2 class="resource__heading" v-else>Edit slider</h2>

      <form class="form" @submit.prevent="onSubmit">
        <div class="form__row mb2">
          <div class="grid">
            <div class="grid__column--nine">
              <div class="form__group">
                <label class="form__label" for="title">Title:</label>
                <span class="form__error" v-if="errors.has('Title')">{{ errors.first('Title') }}</span>
                <input
                  type="text" id="title" name="title"
                  class="form__input mb0" :class="{ 'form__input--error': errors.has('title') }"
                  v-validate="{ required: true }"
                  v-model="slider.title"
                />
              </div>
            </div>
            <div class="grid__column--three">
              <button type="submit" class="btn btn--primary btn--nextToInput" v-if="action === 'create'">PUBLISH</button>
              <button type="submit" class="btn btn--primary btn--nextToInput" v-else>UPDATE TITLE NAME</button>
            </div>
          </div>
        </div>

        <div v-if="slides.length > 0">
          <draggable class="slides__header" v-model="slides">
            <li v-for="slide in slides" :key="slide.id" class="slides__headerTitle" :class="{'slides__headerTitle--active': (slide === activeSlide)}" @click="setActive(slide)">
              <template v-if="slide.title">{{ slide.title }}</template>
              <template v-else>New slide</template>
            </li>
            <li class="slides__headerTitle slides__headerTitle--add" @click="addSlide">Add slide</li>
          </draggable>
          <Slide v-bind:activeSlide.sync="activeSlide" v-bind:slides.sync="slides" @deleteSlide="deleteSlide"/>
        </div>
        <div class="center" v-else>
          <template v-if="action == 'edit'">
            <h2>Let's add your first slide</h2>
            <button type="button" class="btn btn--primary" @click="addSlide">Add slide</button>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Slider from '@/model/Slider'
import SlideModal from '@/model/Slide'
import Slide from '@/components/Slider/Slide'
import {submitResource} from '@/helpers/handleForm'
import draggable from 'vuedraggable'

export default {
  components: {
    Slide, draggable
  },
  props: {
    action: {
      type: String,
      default: 'edit'
    },
    slider: {
      type: Object,
      default () {
        return {
        }
      }
    },
    slides: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      activeSlide: {}
    }
  },
  mounted () {
    if (this.slides.length > 0) {
      this.activeSlide = this.slides[0]
    }
  },
  methods: {
    onSubmit () {
      submitResource(this.$validator, Slider, this.slider, this.action)
    },
    addSlide () {
      let slide = this.defaultSlide()
      this.slides.push(slide)
      this.setActive(slide)
    },
    setActive (slide) {
      this.activeSlide = slide
    },
    deleteSlide () {
      swal({
        title: 'Are you sure you wish to delete this slide?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          SlideModal.delete(this.slider.id, this.activeSlide).then((response) => {
            this.slides.splice(this.slides.indexOf(this.activeSlide), 1)

            if (this.slides.length > 0) {
              this.activeSlide = this.slides[0]
            } else {
              this.activeSlide = {}
            }

            this.$snotify.success('Successfully deleted.')
          })
        }
      })
    },
    defaultSlide () {
      return {
        title: '',
        sub_title: '',
        description: '',
        active: true,
        slider_id: this.$route.params.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider/SliderForm.vue